import { useNavigate } from 'react-router-dom';

import { getTbmsParams } from '@Utils/getApiUrl';
import { MInput } from '@Components/Base';
import {
  useAppSelector,
  useAppsMenuConfig,
  useRoutePrefix,
} from '@Hooks/index';
import { useGetEmpPhotoQuery } from '@Store/api/dictionaryApiSlice';
import { currentUserSelector } from '@Store/selectors/userInfoSelector';
import { ConfigItem } from '@Types/index';

import BaseConfigItems from '@Enum/BaseConfigItems.enum';
import { currentTokenJSONKey } from '@Store/selectors/authSelector';
import { AppsPopover, DarkMode, Notify, UserProfile } from './components';
import styles from './header-application.module.css';
import TrojanHeader from './TrojanHeader';
import { getProfilePagePath } from './utils';

interface HeaderApplicationProps {
  logoComponent?: JSX.Element;
  appsText?: string;
}

const HeaderApplication: React.FC<HeaderApplicationProps> = ({
  logoComponent,
  appsText = '',
}) => {
  const configPopoverContent = useAppsMenuConfig();
  const navigate = useNavigate();
  const user = useAppSelector(currentUserSelector);
  const sessionTokenJSONKey = useAppSelector(currentTokenJSONKey);
  const routePrefix = useRoutePrefix();
  const { tbmsPortalUrl } = getTbmsParams();

  const { data: userPhoto } = useGetEmpPhotoQuery(user.empImageName || '');

  const handleProfileClick = (): void => {
    const profilePagePath = getProfilePagePath(routePrefix);
    navigate(profilePagePath);
  };

  const getRedirectURLToTBMS = async (): Promise<void> => {
    const tokenJSON = sessionStorage.getItem(sessionTokenJSONKey);
    if (tokenJSON) {
      const response = await fetch(tbmsPortalUrl, {
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: tokenJSON,
      });

      const result = await response.json();

      if (result && result.status === 'success') {
        window.open(result.returnUrl, '_blank');
      }
    }
  };

  const updatedContentItems = configPopoverContent.map((item: ConfigItem) =>
    item.title === BaseConfigItems.TBMS
      ? {
          ...item,
          onClick: () => {
            getRedirectURLToTBMS();
          },
        }
      : item
  );

  return (
    <TrojanHeader>
      {logoComponent}
      <div className={styles.headerActionItemsSection}>
        <div className={styles.itemsSection}>
          <MInput
            searchInput
            sizeSearchIcon="large"
            className={styles.searchInput}
            placeholder="Search requests, approvals, employee..."
          />
        </div>
        <div className={styles.itemsWrapper}>
          <div className={styles.itemsSection}>
            <DarkMode />
          </div>
          <div className={styles.itemsSection}>
            <Notify />
          </div>
          <div className={styles.itemsSection}>
            <UserProfile
              avatarImg={userPhoto}
              userName={user.empName}
              onClick={handleProfileClick}
            />
          </div>
        </div>
        <div className={styles.appsContainer}>
          <AppsPopover
            configPopoverContent={updatedContentItems}
            appsText={appsText}
          />
        </div>
      </div>
    </TrojanHeader>
  );
};

export default HeaderApplication;
